import { render, staticRenderFns } from "./DeptMcnPanel.vue?vue&type=template&id=b331eaaa&scoped=true"
import script from "./DeptMcnPanel.vue?vue&type=script&lang=js"
export * from "./DeptMcnPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b331eaaa",
  null
  
)

export default component.exports